<template>
	<div class="flex-item dicom-container">
		<div class="dicom-flex-container">

			<div ref="dicomBorder" class="dicom-flex-column dicom-main-container">
				<div v-if="app.loadError" class="dicom-load-error">{{ app.loadError }}</div>
				<!-- <div ref="dicomBorder" class="dicom-border"></div> -->
				<div ref="dicomViewer" class="dicom-viewer"></div>

				<div v-show="!app.isAnnotating && !app.isCeph" class="rotate-tools 3d-off-item">
					<img class="dicom-flip-btn" v-on:click="flipVertical()" title="Flip Vertical"
						src="images/flip_vertical_white.png" />
					<img class="dicom-flip-btn" v-on:click="flipHorizontal()" title="Flip Horizontal"
						src="images/flip_horizontal_white.png" />

					<img class="dicom-rotate-btn" v-on:click="rotateClockwise()" title="Rotate Clockwise"
						src="images/rotate_right_white.png" />
					<img class="dicom-rotate-btn" v-on:click="rotateCounterClockwise()" title="Rotate Counterclockwise"
						src="images/rotate_left_white.png" />
					<input v-model="rotationStep" class="form-control form-control-sm dicom-rotate-ctrl" type="number"
						min="1" max="359" step="1" />
				</div>

				<div class="dicom-tools" :style="{ 'margin-left': app.is3D ? '100px' : '0px' }">
					<img v-if="!app.isMobileDevice"
						:src="app.toolName == 'dragDrop' ? 'images/drag_red.png' : 'images/drag_white.png'"
						class="dicom-tool-btn annotation-off-item" v-on:click="toolChanged('dragDrop')"
						title="Drag&Drop" />
					<img v-if="!app.isMobileDevice"
						:src="app.toolName == 'measure' ? 'images/measure_red.png' : 'images/measure_white.png'"
						class="dicom-tool-btn annotation-off-item" v-on:click="toolChanged('measure')"
						title="Measure" />
					<img v-if="!app.isMobileDevice"
						:src="app.toolName == 'angle' ? 'images/angle_red.png' : 'images/angle_white.png'"
						class="dicom-tool-btn annotation-off-item dicom-angle-tool" v-on:click="toolChanged('angle')"
						title="Angle" />
					<!-- <img v-if="!app.isMobileDevice"
						v-show="!app.isNoTeeth && !app.isReadonly && app.index == 0 && !app.isAnnotating"
						class="dicom-tool-btn annotation-tool" v-on:click="toolChanged('annotation')" title="Annotation"
						:src="app.isAnnotating ? 'images/annotation_red.png' : 'images/annotation_white.png'" /> -->

					<img v-if="app.isMobileDevice" class="dicom-tool-btn dicom-switch-btn"
						v-on:click="switchDicomView()" title="Switch dicom view" src="images/switch_white.png" />

					<!-- :style="{ backgroundColor: app.isSaving ? 'grey' : 'transparent' }"  -->
					<img v-show="app.isAnnotating" class="dicom-tool-btn annotation-save-btn"
						v-on:click="saveOnServer()" title="Save on server" src="images/save_blue.png" />
					<img v-show="app.isAnnotating" class="dicom-tool-btn annotation-nrrd-btn"
						v-on:click="saveAllNrrdsClick()" title="Save NRRD zip" src="images/download_blue.png" />
					<img v-show="app.isAnnotating" class="dicom-tool-btn annotation-view-btn"
						v-on:click="switchViewClick()" title="Switch view"
						:src="app.is3D ? 'images/3d_red.png' : 'images/3d_blue.png'" />
					<img v-show="app.isAnnotating && app.is3D && !app.isDicom3DView"
						class="dicom-tool-btn annotation-numbers-btn" v-on:click="switchTeethNumbersClick()"
						:title="app.showTeethNumbers ? 'Hide teeth numbers' : 'Show teeth numbers'"
						:src="app.showTeethNumbers ? 'images/numbers_red.png' : 'images/numbers_blue.png'" />

					<img v-show="isBezierEnabled && !isNerve" class="dicom-tool-btn annotation-contour-btn"
						v-on:click="changeDicomEditMode('bezier')" title="Contour Tool"
						:src="!isBrushMode ? 'images/bezier_red.png' : 'images/bezier_white.png'" />
					<img v-show="isDrawEnabled && !isNerve" class="dicom-tool-btn annotation-brush-btn"
						v-on:click="changeDicomEditMode('brush', 'draw')" title="Brush Tool"
						:src="isBrushMode ? 'images/brush_red.png' : 'images/brush_white.png'" />

					<img v-show="isBrushModeAndEdit && !isNerve" class="dicom-tool-btn annotation-draw-btn"
						v-on:click="changeDicomEditMode('brush', 'draw')" title="Draw"
						:src="isBrushDraw ? 'images/draw_red.png' : 'images/draw_white.png'" />
					<img v-show="isBrushModeAndEdit && !isNerve" class="dicom-tool-btn annotation-erase-btn"
						v-on:click="changeDicomEditMode('brush', 'erase')" title="Erase"
						:src="isBrushDraw ? 'images/erase_white.png' : 'images/erase_red.png'" />


					<div v-show="isBrushModeAndEdit && !isNerve" class="input-group mb-2 mt-1 input-group-sm">
						<!-- <div class="input-group-prepend">
							<span class="input-group-text">Size:</span>
						</div> -->
						<select v-model="drawSize" class="form-control form-control-sm dicom-tool-select"
							@change="drawSizeChanged()">
							<option v-for="option in drawSizes" v-bind:value="option">
								{{ option }}
							</option>
						</select>
					</div>

					<img v-show="isAnnotating && !isNerve" class="dicom-tool-btn annotation-undo-btn"
						src="images/undo_white.png" title="Undo" v-on:click="undoBrushEdit()" />

					<img v-show="isAnnotating && !isNerve" class="dicom-tool-btn annotation-redo-btn"
						src="images/redo_white.png" title="Redo" v-on:click="redoBrushEdit()" />

					<!-- <img class="dicom-tool-btn" v-on:click="downloadStlZip()"
						 title="Download STL zip" src="images/dcm_download_white.png" /> -->
				</div>

				<div v-show="app.isSaving" class="annotation-save-hint">
					<span>Saving changes...</span>
					<img class="annotation-save-img" src="images/dark-blue-spinner.gif" />
				</div>

				<img ref="annotationSpinner" class="annotation-spinner" src="images/dark-blue-spinner.gif" />

				<img v-if="app.isSaggital" class="dicom-btn dicom-ceph-btn annotation-off-item"
					:src="app.isCeph ? 'images/ceph_red2.png' : 'images/ceph_white2.png'"
					v-on:click="switchCephClicked()" title="Ceph" />

				<img class="dicom-btn dicom-snapshot-btn annotation-off-item" src="images/snapshot_white.png"
					v-on:click="snapshotClicked()" title="Save Snapshot" />

				<img v-show="!app.isCeph" class="dicom-btn dicom-nobackground-btn annotation-off-item"
					:src="noBackground ? 'images/nobackground_red.png' : 'images/nobackground_white.png'"
					v-on:click="noBackgroundClicked()" title="No Backround" />

				<img v-show="!app.isCeph" v-if="!app.isOnlyDicom" class="dicom-btn dicom-layer-btn annotation-off-item"
					:src="show3DLayer ? 'images/layer_red.png' : 'images/layer_white.png'"
					v-on:click="show3DLayerChanged()" title="Show slice in 3D" />

				<img v-show="!app.isCeph" v-if="!app.isOnlyDicom"
					class="dicom-btn dicom-segmentation-btn annotation-off-item"
					:src="showSegmentation ? 'images/segmentation_red.png' : 'images/segmentation_white.png'"
					v-on:click="showSegmentationChanged()" title="Segmentation" />

				<img v-show="!app.isCeph" class="dicom-btn dicom-intersection-btn 3d-off-item"
					:src="showIntersection ? 'images/intersection_red.png' : 'images/intersection_white.png'"
					v-on:click="showIntersectionChanged()" title="Show projection lines" />

				<img v-show="!app.isCeph" class="dicom-btn dicom-settings-btn 3d-off-item" ref="dicomSettingsBtn"
					data-toggle="collapse" data-target="#dicomSettingsPanel" aria-expanded="false" title="Settings"
					src="images/menu_white.png" />

				<img class="dicom-btn dicom-close-btn annotation-off-item" src="images/cross_white.png"
					v-on:click="closeDicomViewer()" title="Close" />

				<!-- dicomSettingsPanel -->
				<div class="dicom-ctrls panel-group">
					<div id="dicomSettingsPanel" ref="dicomSettingsPanel"
						class="collapse list-group dicom-settings-panel">
						<li v-if="!app.isOnlyDicom"
							class="list-group-item dicom-setting-item active annotation-off-item">Segmentation</li>
						<li v-if="!app.isOnlyDicom" class="list-group-item dicom-setting-item annotation-off-item">
							<div class="mb-2 mt-1 dicom-setting-group">
								<label v-for="option in segmentations" class="dicom-ctrl">
									<span class="dicom-check-label">{{ option.text }}</span>
									<input type="checkbox" class="dicom-check-input" v-model="option.value"
										@change="segmentationChanged()">
								</label>
							</div>
							<div class="input-group mb-2 mt-1 input-group-sm">
								<div class="input-group-prepend">
									<span class="input-group-text">Thickness:</span>
								</div>
								<select v-model="outlineThickness" class="form-control form-control-sm"
									@change="outlineThicknessChanged()">
									<option v-for="option in outlineThicknesses" v-bind:value="option">
										{{ option }}
									</option>
								</select>
							</div>
							<div class="input-group mb-1 mt-1 input-group-sm">
								<div class="input-group-prepend">
									<span class="input-group-text">Opacity:</span>
								</div>
								<input v-model="opacity" @change="opacityChanged()" class="form-control form-control-sm"
									type="number" min="0.05" max="1" step="0.05" />
							</div>
							<div class="input-group mb-1 input-group-sm">
								<select v-model="segmentationType" class="form-control form-control-sm"
									@change="segmentationTypeChanged()">
									<option v-for="option in segmentationTypes" v-bind:value="option.value">
										{{ option.text }}
									</option>
								</select>
							</div>
							<button type="button" class="btn btn-secondary btn-sm btn-block dicom-setting-btn mt-2"
								v-on:click="calculateSegmentation">Calculate</button>
							<!-- {{ app.isLoading ? "Calculate" : "Stop" }} -->
						</li>
						<li v-if="!app.isOnlyDicom"
							class="list-group-item dicom-setting-item active annotation-off-item">3D View</li>
						<li v-if="!app.isOnlyDicom" class="list-group-item dicom-setting-item annotation-off-item">
							<label class="dicom-ctrl">
								<span class="dicom-check-label">Show slice</span>
								<input type="checkbox" class="dicom-check-input" v-model="show3DSlice"
									@change="show3DSliceChanged()">
							</label>
							<label class="dicom-ctrl mt-1">
								<span class="dicom-check-label">Show border</span>
								<input type="checkbox" class="dicom-check-input" v-model="show3DBorder"
									@change="show3DBorderChanged()">
							</label>
							<label class="dicom-ctrl mt-1">
								<span class="dicom-check-label">Show filler</span>
								<input type="checkbox" class="dicom-check-input" v-model="show3DFiller"
									@change="show3DFillerChanged()">
							</label>
							<div class="input-group mb-1 mt-1 input-group-sm">
								<div class="input-group-prepend">
									<span class="input-group-text">Opacity:</span>
								</div>
								<input v-model="sliceOpacity" @change="sliceOpacityChanged()"
									class="form-control form-control-sm" type="number" min="0.05" max="1" step="0.05" />
							</div>
						</li>

						<li v-if="!app.isOnlyDicom"
							class="list-group-item dicom-setting-item active annotation-on-item">Layer Thickness</li>
						<li v-if="!app.isOnlyDicom" class="list-group-item dicom-setting-item annotation-on-item">
							<!-- <div class="mb-2 mt-1 dicom-setting-group"> -->

							<label class="dicom-ctrl">
								<span class="dicom-check-label">Multi-layer</span>
								<input type="checkbox" class="dicom-check-input" v-model="isMultiLayer"
									@change="isMultiLayerChanged()">
							</label>

							<label class="dicom-ctrl">
								<span class="dicom-check-label">Replace On Edit</span>
								<input type="checkbox" class="dicom-check-input layer-thickness-input"
									v-model="isReplaceLayers" @change="isReplaceLayersChanged()">
							</label>


							<div class="input-group mb-1 mt-1 input-group-sm">
								<div class="input-group-prepend">
									<span class="input-group-text layer-thickness-span">Up:</span>
								</div>
								<input v-model="upLayerThickness" @change="upLayerThicknessChanged()"
									class="form-control form-control-sm layer-thickness-input" type="number" min="0"
									max="10" step="1" />
							</div>

							<div class="input-group mb-1 mt-1 input-group-sm">
								<div class="input-group-prepend">
									<span class="input-group-text layer-thickness-span">Down:</span>
								</div>
								<input v-model="downLayerThickness" @change="downLayerThicknessChanged()"
									class="form-control form-control-sm layer-thickness-input" type="number" min="0"
									max="10" step="1" />
							</div>
							<!-- </div> -->

							<!-- <label id="lbEditAllLayers" class="dicom-ctrl">
								<span class="dicom-check-label">Edit all layers</span>
								<input type="checkbox" class="dicom-check-input" v-model="isEditAllLayers"
									@change="isEditAllLayersChanged()">
							</label> -->
						</li>

						<li class="list-group-item dicom-setting-item active">Contrast</li>
						<li class="list-group-item dicom-setting-item">
							<input type="range" class="form-control-range" v-model="contrast.value" :min="contrast.min"
								:max="contrast.max" :step="contrast.step" @input="contrastChanged()"
								@mouseup="updateCanvas()">
							<button type="button" class="btn btn-secondary btn-sm btn-block dicom-setting-btn"
								v-on:click="resetContrast">Reset</button>
						</li>
						<li class="list-group-item dicom-setting-item active">Brightness</li>
						<li class="list-group-item dicom-setting-item">
							<input type="range" class="form-control-range" v-model="brightness.value"
								:min="brightness.min" :max="brightness.max" :step="brightness.step"
								@input="brightnessChanged()" @mouseup="updateCanvas()">
							<button type="button" class="btn btn-secondary btn-sm btn-block dicom-setting-btn"
								v-on:click="resetBrightness">Reset</button>
						</li>
					</div>
				</div>
				<!-- end dicomSettingsPanel -->

				<div class="dicom-zoom-container 3d-off-item">
					<img src="images/white_plus.png" class="dicom-zoom-btn" v-on:click="changeZoom(1)"
						title="Increase Zoom" />
					<img src="images/white_minus.png" class="dicom-zoom-btn" v-on:click="changeZoom(-1)"
						title="Decrease Zoom" />
					<img src="images/reset.png" class="dicom-zoom-btn" v-on:click="resetZoom()" title="Reset" />
				</div>

				<div v-show="!app.isCeph" class="dicom-slider-container 3d-off-item">
					<img class="dicom-slider-btn" src="images/arrow_top_white.png" title="Next Slice"
						v-on:click="moveSliceStep(1)" />
					<span class="dicom-span">{{ max }}</span>
					<div ref="dicomSlider" class="dicom-slider"></div>
					<span class="dicom-span">1</span>
					<img class="dicom-slider-btn" src="images/arrow_bottom_white.png" title="Previous Slice"
						v-on:click="moveSliceStep(-1)" />
				</div>
				<div v-show="!app.isCeph" class="dicom-offset 3d-off-item"> {{ offset }} </div>

				<img class="dicom-btn trash-tool" src="images/trash_icon.png"
					v-show="app.toolName === 'measure' || app.toolName === 'angle'" v-on:click="clearMeasures()"
					title="Clear Measures" />

				<div class="assign-layer annotation-on-item">
					<AssignAnnotationPanel :app="app" />
				</div>

				<!-- <DicomLoader :app="app" /> -->
			</div>

			<div class="dicom-flex-column annotation-column viewers-column annotation-on-item">
				<div ref="dicomAnnotationViewers" class="dicom-annotation-viewers">
					<!-- <SimpleDicomViewer :app="{ orientation: 'axial' }" />
					<SimpleDicomViewer :app="{ orientation: 'sagittal' }" />
					<SimpleDicomViewer :app="{ orientation: 'coronal' }" /> -->
				</div>
			</div>

			<div class="dicom-flex-column annotation-column apanel-column annotation-on-item">
				<DicomAnnotationPanel v-show="app.isAnnotating" :app="app" style="min-width: 174px;" />
				<AnalysisListPanel v-show="!app.isAnnotating" :app="app" style="min-width: 174px;" />
			</div>
		</div>

	</div>
</template>

<script>

import swal from "sweetalert";

import { mutationTypes } from '@/store/modules/dicom';
import {
	Apps, updateAppToRotations,
	attachAppEvents, update3DFrame, updateCanvasContext,
	updateSegmentation, showLoaderPopup, getCephImgData,
	updateOriginBox, setSliceIndex, setupCanvasEvents,
	changeAppZoom, changeAppTool, changeEditMode,
	updateSliceIntersection, resetProjections, removeSliceIntersection,
	switch3DView, switchTeethNumbers, closeViewer, switchToNextApp
} from "./DicomManager";

import AnalysisListPanel from "./analysis/AnalysisListPanel.vue";
import DicomAnnotationPanel from "./controls/DicomAnnotationPanel.vue";
import AssignAnnotationPanel from "./assign/AssignAnnotationPanel.vue";
import { saveAllAnnotationNrrds, saveAnnotationZip, updateTeethOnServer } from "./annotation";
import { makeSnapshot } from "@/components/reports/ReportsManager";

let dwv = require('dwv');
const ONLY_TEETH = "OnlyTeeth";
const MAXILLA = "maxilla";
const MANDIBLE = "mandible";
const AIRWAY = "airway";
const NERVE = "nerve";
const GINGIVA = "gingiva";
const MAXTEETH = "maxTeeth";
const MANDTEETH = "mandTeeth";
const rotateStep = 15;

export default {
	name: "DicomViewer",
	components: {
		AnalysisListPanel,
		DicomAnnotationPanel,
		AssignAnnotationPanel
	},
	data() {
		return {
			current: 0,
			currentRotateAngle: 0,
			rotationStep: 15,
			currentFlipX: 1,
			currentFlipY: 1,
			max: 100,
			sliderId: null,
			settingsPanelId: 'settingsPanelId',
			showSegmentation: true,
			segmentations: [
				{ text: "Max teeth", key: MAXTEETH, value: true },
				{ text: "Mand teeth", key: MANDTEETH, value: true },
				{ text: "Max. Comp.", key: MAXILLA, value: true },
				{ text: "Mandible", key: MANDIBLE, value: true },
				{ text: "Airway", key: AIRWAY, value: true },
				{ text: "Nerve", key: NERVE, value: true },
				{ text: "Gingiva", key: GINGIVA, value: true },
			],
			segmentationType: 'outlines',
			segmentationTypes: [
				{ text: "Outlines", value: 'outlines' },
				{ text: "Fill Teeth", value: 'fillTeeth' },
				{ text: "Fill All", value: 'fillAll' }
			],

			showIntersection: true,
			show3DLayer: true,
			noBackground: false,

			opacity: 0.8,
			rotation: 0,
			show3DSlice: false,
			show3DBorder: false,
			show3DFiller: true,
			sliceOpacity: 0.25,
			contrast: {
				value: 50,
				min: 1,
				max: 100,
				step: 1,
				default: 50
			},
			brightness: {
				value: 50,
				min: 1,
				max: 100,
				step: 1,
				default: 50
			},
			outlineThicknesses: [
				0.3,
				0.6,
				1.0,
				1.5
			],
			outlineThickness: 1,
			drawSizes: [
				1,
				2,
				3,
				4,
				5,
				6
			],
			drawSize: 3,
			renderChanged: false,
			isMultiLayer: true,
			isReplaceLayers: false,
			upLayerThickness: 0,
			downLayerThickness: 0,
			isEditAllLayers: false
		}
	},
	props: {
		app: {
			type: Object,
			required: true
		}
	},
	computed: {
		offset() {
			return `${this.current} / ${this.max}`;
		},
		isNerve() {
			return this.app.index > 0;
		},
		isBezierEnabled() {
			return this.app.isAnnotating && !this.app.is3D;
			//this.app.isAnnotating && !this.app.is3D && (!this.app.editedAnnotation || this.app.editedAnnotation.isTooth);
		},
		isDrawEnabled() {
			return this.app.isAnnotating && !this.app.is3D;
		},
		isBrushMode() {
			return this.app.isAnnotating && !this.app.is3D && this.app.editMode === 'brush';
		},
		isBrushModeAndEdit() {
			return this.app.isAnnotating && this.app.isEditingAnnotation && !this.app.is3D && this.app.editMode === 'brush';
		},
		isEditingAnnotation() {
			return this.app.isAnnotating && this.app.isEditingAnnotation && !this.app.is3D;
		},
		isAnnotating() {
			return this.app.isAnnotating && !this.app.is3D;
		},
		isBrushDraw() {
			return this.app.isAnnotating && !this.app.is3D
				&& this.app.editMode === 'brush' && this.app.editSubMode === 'draw';
		}
	},
	mounted() {
		if (!this.app.divId || this.app.divId == 'demo_dicom') {
			console.log("demo mounted");
			//this.app = { orientation : "axial" };
			this.$store.commit(mutationTypes.isAxialChange, true);
			this.initControls();
			this.app.setTool = (toolName) => {
				console.log("demo setTool", toolName);
			};
			this.app.setToolFeatures = (features) => {
				console.log("demo setToolFeatures", features);
			};
			this.app.viewersId = `${this.app.orientation}_viewers`;
			this.$refs.dicomAnnotationViewers.setAttribute("id", this.app.viewersId);
			this.app.isDemo = true;
			this.$refs.dicomViewer.setAttribute("id", this.app.divId);

			window.addEventListener('resize', () => {
				if (this.showIntersection)
					updateSliceIntersection(this.app);
			});
			return;
		}
		let app = this.app;
		app.viewer = this;
		// console.log(`mounted app ${app.index}`);
		this.app.outlineThickness = this.outlineThickness;
		this.app.segmentationType = this.segmentationType;

		this.$refs.dicomViewer.setAttribute("id", this.app.divId);
		console.log("DicomViewer mounted", this.app.divId);

		this.app.containerId = `${this.app.orientation}_cont`;
		this.$el.setAttribute("id", this.app.containerId);

		this.app.borderId = `${this.app.orientation}_border`;
		this.$refs.dicomBorder.setAttribute("id", this.app.borderId);
		this.$refs.dicomBorder.setAttribute("style", `border: solid ${this.app.color} 0.2rem;`);

		this.app.viewersId = `${this.app.orientation}_viewers`;
		this.$refs.dicomAnnotationViewers.setAttribute("id", this.app.viewersId);

		const viewConfig = new dwv.ViewConfig(app.divId);
		viewConfig.orientation = app.orientation;

		const viewConfigs = { '*': [viewConfig] };
		const options = new dwv.AppOptions(viewConfigs);
		var shapeList = [
			'Arrow',
			'Ruler',
			'Protractor',
			'Rectangle',
			'Roi',
			'Ellipse',
			'Circle',
			'FreeHand',
			'Empty'
		];
		options.tools = {
			ZoomAndPan: {},
			Livewire: {},
			Annotation: {},
			Floodfill: {},
			Draw: {
				options: shapeList,
				type: 'factory'
			}
		};
		options.viewOnFirstLoadItem = false;
		app.init(options);
		app.tools = options.tools;

		app.addEventListener('load', (event) => {
			console.log(`app ${app.index} load`, event);
			if (app.loadErrors && app.loadErrors.length > 0) {
				return;
			}

			app.setTool('ZoomAndPan');
			let image = app.getLastImage();
			if (!image) {
				const layerGroup = app.getLayerGroupByDivId(app.divId);
				const activeLayer = layerGroup.getActiveViewLayer();
				const viewController = activeLayer.getViewController();
				image = viewController.getViewImage();
			}
			// for (let i = 0; i < 100; i++) {
			// 	image = app.getImage(i);
			// 	if (image)
			// 		break;
			// }
			if (image) {
				const size = image.getGeometry().getSize();
				this.max = app.max = size.get(app.viewIndex);
				this.current = app.current = Math.floor(app.max / 2) + 1;
				// console.log(`app ${app.index} size`, size);
				console.log(`app ${app.index}, max ${app.max} load`, event);
				this.initControls();
			}
		});
		app.addEventListener('loadstart', (event) => {
			console.log(`app ${app.index} loadstart`, event);
		});
		app.addEventListener('renderend', () => {
			if (!app.baseSize) {
				// console.log(`app ${app.index} renderend`, event);
				const activeLayer = this.getActiveLayer();
				app.baseSize = activeLayer.getBaseSize();
				const viewController = activeLayer.getViewController();
				app.worldSize = viewController.getImageWorldSize();
				app.spacing = viewController.get2DSpacing();
				app.geometry = viewController.getViewImage().getGeometry();
				//app.getImage(0).getGeometry();
				app.size = app.geometry.getSize().getValues();
				app.spacing = app.geometry.getSpacing().getValues();
				var origin = app.geometry.getOrigin();
				app.origin = [+origin.getX(), +origin.getY(), +origin.getZ()];

				// app.baseSize = { x: app.worldSize.x / app.spacing[0], y: app.worldSize.y / app.spacing[1] };
				console.log(`app ${app.index} renderend`, app);
				setupCanvasEvents(app);

				this.initImageSettings();
				updateOriginBox(app, viewController);

				setTimeout(function () {
					changeAppTool(app, app.toolName);
				}, 100);
			}
			this.renderChanged = true;
		});
		app.addEventListener('loadabort', (event) => {
			console.log(`app ${app.index} loadabort`, event);
		});
		app.addEventListener('loaderror', (event) => {
			console.log(`app ${app.index} loaderror`, event);
			if (!app.loadErrors) {
				app.loadErrors = [];
			}
			app.loadErrors.push(event);
		});
		attachAppEvents(app, this);
		// setupCanvasEvents(app);

		window.addEventListener('resize', () => {
			try {
				if (app.visible) {
					console.log(`app ${app.index} resized`);
					let currentConfigs = app.getDataViewConfigs();
					app.setDataViewConfigs(currentConfigs);
					for (let i = 0; i < app.getNumberOfLoadedData(); ++i) {
						app.render(i);
					}
					changeAppTool(app, app.toolName);
					// app.onResize();
					// updateCanvasContext(app);
					updateAppToRotations(app);
					if (app.showIntersection)
						updateSliceIntersection(app);
				}
				// attachAppEvents(app, this);
				setupCanvasEvents(app);
			} catch (error) {
				console.error(error);
			}
		});


		this.segmentations[2].value = vueApp.maxillaBone && vueApp.maxillaBone.isVisible;
		this.segmentations[3].value = vueApp.mandibleBone && vueApp.mandibleBone.isVisible;
		this.segmentations[4].value = vueApp.airways.length && vueApp.airways[0].isVisible;
		this.segmentations[5].value = vueApp.nerves.length && vueApp.nerves[0].isVisible;
		this.segmentations[6].value = vueApp.gingivae.length && vueApp.gingivae.find(g => g.isVisible);

		vueApp.$on("visibilityChanged", (target) => {
			console.log(`visibilityChanged dicom viewer`, target);
			if (target == vueApp.maxillaBone) {
				this.segmentations[2].value = target.isVisible;
			}
			else if (target == vueApp.mandibleBone) {
				this.segmentations[3].value = target.isVisible;
			}
			else if (vueApp.airways.length && target == vueApp.airways[0]) {
				this.segmentations[4].value = target.isVisible;
			} else if (vueApp.nerves.length && target == vueApp.nerves[0]) {
				this.segmentations[5].value = target.isVisible;
			} else if (vueApp.gingivae.length && target.isGingiva) {
				this.segmentations[6].value = vueApp.gingivae.find(g => g.isVisible);
			} else if (target && target.name) {
				if (target.name == ONLY_TEETH) {
					this.segmentations[2].value =
						this.segmentations[3].value =
						this.segmentations[4].value =
						this.segmentations[5].value =
						false;
				}
				else if (target.name.toLowerCase() == MAXILLA) {
					this.segmentations[0].value = target.isVisible;
				}
				else if (target.name.toLowerCase() == MANDIBLE) {
					this.segmentations[1].value = target.isVisible;
				}
			}
		});
	},
	beforeDestroy() {
		// if (vueApp) {
		// 	vueApp.$off('colorChanged');
		// 	vueApp.$off('visibilityChanged');
		// 	vueApp.$off('positionChanged');
		// 	vueApp.$off('toothAdded');
		// 	vueApp.$off('toothRemoved');
		// }
	},
	methods: {
		initControls: function () {
			if (this.app) {
				// console.log("initControls", this.app.divId);
				this.app.containerId = `${this.app.orientation}_cont`;
				this.$el.setAttribute("id", this.app.containerId);
				this.sliderId = `${this.app.orientation}_slider`;
				this.$refs.dicomSlider.setAttribute("id", this.sliderId);
				$(`#${this.sliderId}`).slider({
					orientation: "vertical",
					min: 0,
					max: this.max,
					step: 1,
					value: this.current,
					slide: (slideEvent, ui) => {
						setSliceIndex(this.app, ui.value - 1);
					}
				});

				let settingsPanelId = this.settingsPanelId = `${this.app.orientation}SettingsPanel`; // dicomSettingsPanel
				this.$refs.dicomSettingsPanel.setAttribute("id", settingsPanelId);

				let settingsBtnId = `${this.app.orientation}SettingsBtn`; // dicomSettingsBtn
				this.$refs.dicomSettingsBtn.setAttribute("id", settingsBtnId);
				this.$refs.dicomSettingsBtn.setAttribute("data-target", settingsPanelId);

				this.app.settingsPanelId = settingsPanelId;

				let annotationSpinnerId = `${this.app.orientation}AnnotationSpinner`;
				this.$refs.annotationSpinner.setAttribute("id", annotationSpinnerId);
				this.app.annotationSpinnerId = "#" + annotationSpinnerId;

				$(`#${settingsBtnId}`).on('click', function () {
					$(`#${settingsPanelId}`).collapse('toggle');
				});
			}
		},
		toolChanged: function (toolName) {
			if (toolName) {
				// this.app.toolName = toolName;
				if (toolName == 'annotation') {
					this.resetZoom();
					$(`#${this.settingsPanelId}`).collapse('hide');
				}
				if (this.app) {
					changeAppTool(this.app, toolName);
				}
			}
		},
		switchDicomView: function () {
			switchToNextApp(this.app);
		},
		rotateClockwise: function () {
			this.currentRotateAngle += +this.rotationStep;
			this.applyCurrentTransforms();
		},
		rotateCounterClockwise: function () {
			this.currentRotateAngle -= +this.rotationStep;
			this.applyCurrentTransforms();
		},
		applyCurrentTransforms: function () {
			let appDiv = $(`#${this.app.divId}`);
			// let appDiv = $(`#${this.app.divId}-intersection-vertical,#${this.app.divId}-intersection-horizontal`);
			//#${this.app.divId}-outline-layer, #${this.app.divId}-layer-0>canvas,
			if (appDiv) {
				let angle = this.currentRotateAngle % 360;
				let scaleX = this.currentFlipX;
				let scaleY = this.currentFlipY;

				this.app.isFlippedX = scaleX < 0;
				this.app.isFlippedY = scaleY < 0;
				this.app.rotateDeg = angle;
				this.app.isTransformed = this.app.isFlippedX || this.app.isFlippedY || angle !== 0;

				// this.app.resetZoom();
				// updateCanvasContext(this.app);

				appDiv.css({
					"-webkit-transform": `rotate(${angle}deg) scaleX(${scaleX}) scaleY(${scaleY})`,
					"-moz-transform": `rotate(${angle}deg) scaleX(${scaleX}) scaleY(${scaleY})`,
					"transform": `rotate(${angle}deg) scaleX(${scaleX}) scaleY(${scaleY})`,
				});
			}
		},
		flipVertical: function () {
			console.log("flipVertical");
			this.currentFlipX = -this.currentFlipX;
			this.applyCurrentTransforms();
		},
		flipHorizontal: function () {
			console.log("flipHorizontal");
			this.currentFlipY = -this.currentFlipY;
			this.applyCurrentTransforms();
		},
		clearMeasures: function () {
			console.log("clearMeasures");
			swal({
				text: "Are you sure you want to delete all measures?",
				buttons: {
					yes: { text: "Yes", value: true },
					no: { text: "No", value: false }
				}
			}).then(async (willDelete) => {
				if (willDelete) {
					const drawLayer = this.getDrawLayer();
					if (drawLayer) {
						console.log(drawLayer);
						drawLayer.deleteDraws(() => { });
					}
				}
			});
		},
		initImageSettings: function () {
			const vl = this.getActiveLayer();
			const image = this.app.getImage(vl.getDataIndex());
			// const dataRange = image.getDataRange();
			const rescaledDataRange = image.getRescaledDataRange();
			const vc = vl.getViewController();
			const wl = vc.getWindowLevel();

			this.contrast.min = 0;
			this.contrast.max = rescaledDataRange.max - rescaledDataRange.min;
			this.contrast.step = this.contrast.max / 100;
			this.contrast.default = this.contrast.value = wl.width;

			this.brightness.min = rescaledDataRange.min;
			this.brightness.max = rescaledDataRange.max;
			this.brightness.step = (this.brightness.max - this.brightness.min) / 100;
			this.brightness.default = this.brightness.value = wl.center;
		},
		updateImageSettings: function () {
			const vc = this.getViewController();
			const center = parseFloat(this.brightness.value);
			const width = parseFloat(this.contrast.value);
			vc.setWindowLevel(center, width);
		},
		changeZoom: function (factor) {
			changeAppZoom(this.app, factor);
		},
		resetZoom: function (factor) {
			if (this.app) {
				resetProjections(this.app);

				// this.currentRotateAngle = 0;
				// this.currentFlipX = 1;
				// this.currentFlipY = 1;
				// this.applyCurrentTransforms();
				// this.app.resetZoom();
				// updateCanvasContext(this.app);

				// resetProjections(this.app);
			}
		},
		moveSliceStep: function (step) {
			// console.log("moveSliceStep", step);
			this.current += step;
			this.app.current = this.current;
			setSliceIndex(this.app, this.app.current - 1);
		},
		showSegmentationChanged: function () {
			this.showSegmentation = !this.showSegmentation;
			console.log("showSegmentationChanged", this.showSegmentation);
			if (this.app) {
				this.app.showSegmentation = this.showSegmentation;
				setSliceIndex(this.app, this.current - 1);
				// this.segmentationChanged();
			}
		},
		showIntersectionChanged: function () {
			this.showIntersection = !this.showIntersection;
			this.app.showIntersection = this.showIntersection;
			updateSliceIntersection(this.app);
			// this.applyCurrentTransforms();
		},
		show3DLayerChanged: function () {
			this.show3DLayer = !this.show3DLayer;
			console.log("show3DLayerChanged", this.show3DLayer);
			this.app.show3DLayer = this.show3DLayer;
			update3DFrame(this.app);
		},
		snapshotClicked: async function () {
			let tempIntersection = this.showIntersection;
			removeSliceIntersection(this.app);
			console.log("snapshotClicked", this.app.divId);
			makeSnapshot(this.app.divId);
			if (tempIntersection) {
				updateSliceIntersection(this.app);
			}
		},
		switchCephClicked: async function () {
			let cephImgData = null;
			if (!this.app.isCeph) {
				cephImgData = await getCephImgData(this.app);
				if (!cephImgData) {
					await swal({
						text: "The ceph image is missing.",
					});
					return;
				}
			}

			this.app.isCeph = !this.app.isCeph;
			console.log("switchCephClicked", this.app.isCeph);
			let viewLayer = this.getActiveLayer();

			if (this.app.isCeph) {
				this.app.backgroundImage = viewLayer.backgroundImage = cephImgData;
				$(`#${this.app.settingsPanelId}`).collapse("hide");
				this.app.showIntersection = this.showIntersection = false;
				updateSliceIntersection(this.app);
			} else {
				this.app.backgroundImage = viewLayer.backgroundImage = null;
				this.app.showIntersection = this.showIntersection = true;
				updateSliceIntersection(this.app);
			}

			setSliceIndex(this.app, this.current - 1);
		},
		noBackgroundClicked: function () {
			console.log("noBackgroundClicked");
			let viewLayer = this.getActiveLayer();
			this.noBackground = this.app.noBackground = viewLayer.noBackground = !this.noBackground;
			setSliceIndex(this.app, this.current - 1);
		},
		segmentationChanged: function () {
			let arr = [];
			this.segmentations.forEach(option => {
				if (option.value) {
					arr.push(option.key);
				}
				if (option.key == GINGIVA && vueApp.gingivae.length) {
					vueApp.gingivae.forEach(gingiva => {
						gingiva.isVisible = option.value;
						itemVisibilityChanged(gingiva, vueApp.gingivaeColor);
					});
				}
				if (option.key == NERVE && vueApp.nerves.length) {
					vueApp.nerves[0].isVisible = option.value;
					itemVisibilityChanged(vueApp.nerves[0], vueApp.nervesColor);
				}
				if (option.key == AIRWAY && vueApp.airways.length) {
					vueApp.airways[0].isVisible = option.value;
					itemVisibilityChanged(vueApp.airways[0], vueApp.airwaysColor);
				}
				if (option.key == MAXILLA && vueApp.maxillaBone) {
					let item = vueApp.maxillaBone;
					item.isVisible = option.value;
					itemVisibilityChanged(item, item.color, item.opacity);
				}
				if (option.key == MANDIBLE && vueApp.mandibleBone) {
					let item = vueApp.mandibleBone;
					item.isVisible = option.value;
					itemVisibilityChanged(item, item.color, item.opacity);
				}
				if (option.key == MAXTEETH) {
					var dentation = vueApp.dentations.find(x => x.name.toLowerCase() === MAXILLA);
					console.log(MAXTEETH, option.value, dentation);
					if (dentation) {
						dentation.isVisible = option.value;
						vueApp.allTeeth.forEach(function (item) {
							if (item.dentition == dentation.name) {
								item.isVisible = dentation.isVisible;
								itemVisibilityChanged(item, item.color, vueApp.teethOpacity)
							}
						});
					}
				}
				if (option.key == MANDTEETH) {
					var dentation = vueApp.dentations.find(x => x.name.toLowerCase() === MANDIBLE);
					console.log(MANDTEETH, option.value, dentation);
					if (dentation) {
						dentation.isVisible = option.value;
						vueApp.allTeeth.forEach(function (item) {
							if (item.dentition == dentation.name) {
								item.isVisible = dentation.isVisible;
								itemVisibilityChanged(item, item.color, vueApp.teethOpacity)
							}
						});
					}
				}
			});
			console.log("segmentationChanged", arr);
			// this.showSegmentation = arr.length > 0;
			this.app.segmentations = arr;
			setSliceIndex(this.app, this.current - 1);
		},
		outlineThicknessChanged: function () {
			this.app.outlineThickness = this.outlineThickness;
			console.log("outlineThicknessChanged", this.outlineThickness);
			setSliceIndex(this.app, this.current - 1);
		},
		drawSizeChanged: function () {
			this.app.drawSize = this.drawSize;
			this.app.setToolFeatures({ drawSize: this.drawSize });
		},
		undoBrushEdit: function () {
			this.app.setToolFeatures({ undoAnnotation: true });
		},
		redoBrushEdit: function () {
			this.app.setToolFeatures({ redoAnnotation: true });
		},
		segmentationTypeChanged: function () {
			this.app.segmentationType = this.segmentationType;
			console.log("segmentationTypeChanged", this.segmentationType);
			setSliceIndex(this.app, this.current - 1);
		},
		opacityChanged: function () {
			this.app.opacity = this.opacity;
			setSliceIndex(this.app, this.current - 1);
		},
		contrastChanged: function () {
			// console.log("contrastChanged", this.brightness.value, this.contrast.value);
			this.updateImageSettings();
		},
		brightnessChanged: function () {
			// console.log("brightnessChanged", this.brightness.value, this.contrast.value);
			this.updateImageSettings();
		},
		resetContrast: function () {
			this.contrast.value = this.contrast.default;
			this.contrastChanged();
			this.updateCanvas();
		},
		resetBrightness: function () {
			this.brightness.value = this.brightness.default;
			this.brightnessChanged();
			this.updateCanvas();
		},
		isMultiLayerChanged: function () {
			this.app.isMultiLayer = this.isMultiLayer;
			console.log("isMultiLayerChanged", this.app.isMultiLayer);
			$(`.layer-thickness-input`).prop('disabled', !this.app.isMultiLayer);
		},
		isReplaceLayersChanged: function () {
			this.app.isReplaceLayers = this.isReplaceLayers;
			console.log("isReplaceLayersChanged", this.app.isReplaceLayers);
		},
		isEditAllLayersChanged: function () {
			this.app.isEditAllLayers = this.isEditAllLayers;
			console.log("isEditAllLayersChanged", this.app.isEditAllLayers);
		},
		upLayerThicknessChanged: function () {
			this.app.upLayerThickness = this.upLayerThickness;
			console.log("upLayerThicknessChanged", this.app.upLayerThickness);
		},
		downLayerThicknessChanged: function () {
			this.app.downLayerThickness = this.downLayerThickness;
			console.log("downLayerThicknessChanged", this.app.downLayerThickness);
		},
		show3DSliceChanged: function () {
			this.app.show3DSlice = this.show3DSlice;
			if (this.show3DSlice) {
				setSliceIndex(this.app, this.current - 1);
			} else {
				// updateCanvasContext(this.app);
				update3DFrame(this.app);
			}

		},
		show3DBorderChanged: function () {
			this.app.show3DBorder = this.show3DBorder;
			update3DFrame(this.app);
		},
		show3DFillerChanged: function () {
			this.app.show3DFiller = this.show3DFiller;
			update3DFrame(this.app);
		},
		sliceOpacityChanged: function () {
			this.app.sliceOpacity = this.sliceOpacity;
			update3DFrame(this.app);
		},
		getActiveLayer: function () {
			const layerGroup = this.app.getLayerGroupByDivId(this.app.divId);
			return layerGroup.getActiveViewLayer();
		},
		getDrawLayer: function () {
			const layerGroup = this.app.getLayerGroupByDivId(this.app.divId);
			return layerGroup.getActiveDrawLayer();
		},
		getViewController: function () {
			const activeLayer = this.getActiveLayer();
			return activeLayer.getViewController();
		},
		updateCurrentIndex: function (newCurrent) {
			if (!newCurrent) {
				const viewController = this.getViewController();
				let currentIndex = viewController.getCurrentIndex();
				newCurrent = currentIndex.get(this.app.viewIndex) + 1;
				this.app.current = newCurrent;
			}
			this.current = newCurrent;
			$(`#${this.sliderId}`).slider("value", this.current);
			return this.current;
		},
		updateCanvas: function () {
			if (this.renderChanged) {
				this.renderChanged = false;
				update3DFrame(this.app);
				updateCanvasContext(this.app);
			}
		},
		calculateSegmentation: function () {
			console.log("calculateSegmentation");
			updateSegmentation(this.app, true);
		},
		saveAllNrrdsClick: function () {
			console.log("saveAllNrrdsClick");
			showLoaderPopup(`Preparing NRRD zip`, `Please wait...`);
			setTimeout(() => {
				saveAllAnnotationNrrds(this.app);
				$id("loader").style.display = "none";
			}, 100);
		},
		saveOnServer: function () {
			if (!this.app.isSaving) {
				let smoothChecked = false;
				let nrrdChecked = true;
				swal({
					text: "Are you sure you want to save this segmentation? (previous version will be overwritten)",
					buttons: {
						yes: { text: "OK", value: true },
						no: { text: "Cancel", value: false }
					}
				}).then(async (willUpload) => {
					if (willUpload) {
						console.log("uploading annotation zip...");
						await updateTeethOnServer(Apps[0], smoothChecked, nrrdChecked);
					}
				});

				var $swalCheckbox = $(
					`<div class='swal-checkbox-div'>
					<input class='swal-checkbox-cb' type='checkbox' id='swalCheckbox' checked/> 
					<label class='swal-checkbox-lb' for='swalCheckbox'>Export teeth to NRRD</label>
				</div>`
				);
				$(".swal-footer").append($swalCheckbox);
				$("#swalCheckbox").change(() => {
					nrrdChecked = $("#swalCheckbox").is(":checked");
					// let checked = document.querySelector('#swalCheckbox').checked;
					console.log("swal-checkbox ", nrrdChecked);
				});
			}
		},
		downloadStlZip: function () {
			console.log("downloadStlZip");
			saveAnnotationZip(this.app);
		},
		switchViewClick: function () {
			switch3DView(this.app, !this.app.is3D);
		},
		switchTeethNumbersClick: function () {
			switchTeethNumbers(this.app);
		},
		changeDicomEditMode: function (editMode, editSubMode) {
			changeEditMode(this.app, editMode, editSubMode);
		},
		closeDicomViewer: function () {
			closeViewer(this.app);
		},
	}
};

</script>

<style scoped>
.dicom-container {
	display: none;
	padding: 0;
	justify-content: center;
	/* position: relative; */
	/* color: white; */
	font-family: Montserrat, sans-serif;
	font-size: .875rem;
}

.dicom-flex-container {
	display: flex;
	/* flex-direction: row-reverse; */
	flex-wrap: nowrap;
	width: 100%;
	height: 100%;
	margin: 0;
	/* gap: 3px; */
	align-items: stretch;
	position: relative;
	background-color: white;
	z-index: 10;
}

.dicom-flex-column {
	position: relative;
	background-color: black;
	height: 100%;
	flex-grow: 1;
	box-sizing: border-box;
}

.dicom-load-error {
	position: absolute;
	color: white;
	text-wrap: wrap;
	z-index: 99;
	width: 200px;
	text-align: center;
	top: calc(50% - 23px);
	font-size: 15px;
	left: calc(50% - 100px);
}

.viewers-column {
	width: 25%;
	min-width: 25%;
}

.apanel-column {
	width: 15%;
	overflow-x: auto;
}

.dicom-main-container {
	/* position: static; */
	display: block;
	width: 60%;
	padding: 0.1rem;
	border: solid red 0.2rem;
	overflow: hidden;
}

.dicom-annotation-viewers {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: stretch;
	justify-content: center;
	flex-direction: column;
	gap: 3px;
}

.dicom-viewer {
	width: 100%;
	height: 100%;
	background-color: black;
	/* position: relative; */
	/* margin: 0; */
	/* margin-top: -15px */
}

.dicom-bordered-tool {
	position: absolute;
	color: white;
	border: 1px solid #007bff;
	border-radius: 0.2rem;
	padding: 0.25rem 0.5rem;
}

.dicom-tools {
	position: absolute;
	top: 14px;
	left: 55px;
	display: flex;
	align-items: stretch;
	gap: 14px;
	z-index: 2;
	/* padding: 0 0.25rem; */
}

.rotate-tools {
	position: absolute;
	bottom: 14px;
	left: 55px;
	display: flex;
	align-items: stretch;
	gap: 14px;
	z-index: 2;
	/* padding: 0 0.25rem; */
}

.dicom-rotate-ctrl {
	margin-top: -4px;
	width: 60px;
}

.dicom-rotate-btn {
	width: 23px;
	height: 23px;
	cursor: pointer;
}

.dicom-flip-btn {
	width: 21px;
	height: 21px;
	cursor: pointer;
}

.dicom-tool-btn {
	width: 25px;
	height: 25px;
	cursor: pointer;
}

.dicom-angle-tool {
	width: 32px;
	height: 32px;
	margin-top: -2px;
	margin-left: -3px;
}

.dicom-tool-select {
	height: 25px;
	padding: 2px;
	margin-top: 2px;
}

.trash-tool {
	position: absolute;
	/* top: 12px; */
	bottom: 20px;
	left: calc(50% - 15px);
	width: 30px;
	height: 30px;
	cursor: pointer;
}

.dicom-btn {
	cursor: pointer;
	position: absolute;
	z-index: 2;
}

.dicom-ceph-btn {
	top: 17px;
	right: 288px;
	width: 25px;
	height: 25px;
}

.dicom-snapshot-btn {
	top: 14px;
	right: 250px;
	width: 30px;
	height: 30px;
}

.dicom-nobackground-btn {
	top: 16px;
	right: 215px;
	width: 25px;
	height: 25px;
}

.dicom-layer-btn {
	top: 16px;
	right: 175px;
	width: 25px;
	height: 25px;
}

.dicom-segmentation-btn {
	top: 12.9px;
	right: 135px;
	width: 30px;
	height: 30px;
}

.dicom-intersection-btn {
	top: 12.9px;
	right: 97px;
	width: 30px;
	height: 30px;
}

.dicom-settings-btn {
	top: 12.9px;
	right: 55px;
	width: 30px;
	height: 30px;
}

.dicom-close-btn {
	top: 16px;
	right: 20px;
	width: 25px;
	height: 25px;
}

.dicom-ctrls {
	position: absolute;
	top: 12px;
	right: 45px;
	z-index: 100;
	text-align: right;
	height: calc(100% - 20px);
	width: 0;
	z-index: 2;
}

.dicom-setting-btn {
	margin: 5px 0;
	padding: 0;
}

.dicom-settings-panel {
	position: absolute;
	width: 175px;
	right: -40px;
	top: 40px;
	max-height: calc(100% - 40px);
	overflow-y: scroll;
	/* overflow-y: auto; */
}

.assign-layer {
	display: none;
	position: absolute;
	height: calc(100% - 120px);
	top: 70px;
	left: 70px;
}

.annotation-save-hint {
	position: absolute;
	color: white;
	top: 25px;
	left: calc(50% - 100px);
	text-align: center;
	width: 200px;
}

.annotation-save-img {
	display: inline;
	width: 29px;
	height: 29px;
}

.annotation-spinner {
	position: absolute;
	display: none;
	width: 100px;
	height: 100px;
	left: calc(50% - 50px);
	top: calc(50% - 50px);
	text-align: center;
	z-index: 9;
}

::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px transparent;
	border-radius: 10px;
}

::-webkit-scrollbar-thumb {
	background: transparent;
	border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
	background: #007bff;
}

.dicom-setting-item {
	padding: .3rem .4rem;
}

.dicom-setting-group {
	text-align: right;
	border: 1px solid #ced4da;
	align-items: end;
	border-radius: 0.2rem;
	padding-right: 5px;
	padding-left: 5px;
}

.dicom-ctrl {
	text-align: right;
	display: block;
	white-space: nowrap;
	margin: 0;
}

.dicom-check-label {
	margin-right: 0.5rem;
	vertical-align: middle;
}

.dicom-check-input {
	/* margin-top: 20px; */
	vertical-align: middle;
}

.layer-thickness-span {
	width: 63px;
}

#lbEditAllLayers {
	margin-right: 5px;
	margin-top: -3px;
}

.dicom-offset {
	position: absolute;
	right: 10px;
	bottom: 10px;
	/* z-index: 9; */
	font-size: 1rem;
	color: white;
}

.dicom-zoom-container {
	position: absolute;
	text-align: center;
	width: 35px;
	left: 5px;
	top: 17px;
	z-index: 2;
}

.dicom-zoom-btn {
	width: 20px;
	height: 20px;
	margin-bottom: 12px;
	color: white;
	cursor: pointer;
	/* font-size: 2rem; */
}

.dicom-switch-btn {
	width: 30px;
	height: 30px;
	margin-left: -2px;
	margin-top: -1px;
}

@media (max-width: 430px) {
	.dicom-tools {
		top: 5px;
		left: 42px;
		gap: 12px;
		/* padding: 0 0.25rem; */
	}

	.dicom-tool-btn {
		width: 22px;
		height: 22px;
	}

	.dicom-angle-tool {
		width: 27px;
		height: 27px;
		margin-top: -2px;
		margin-left: -3px;
	}


	.dicom-switch-btn {
		width: 27px;
		height: 27px;
		margin-left: 7px;
		margin-top: -2px;
	}


	.dicom-layer-btn {
		top: 5px;
		right: 150px;
		width: 22px;
		height: 22px;
	}

	.dicom-segmentation-btn {
		top: 2.9px;
		right: 112px;
		width: 27px;
		height: 27px;
	}

	.dicom-intersection-btn {
		top: 2.9px;
		right: 76px;
		width: 27px;
		height: 27px;
	}

	.dicom-settings-btn {
		top: 2.9px;
		right: 38px;
		width: 27px;
		height: 27px;
	}

	.dicom-close-btn {
		top: 5px;
		right: 5px;
		width: 22px;
		height: 22px;
	}

	.dicom-close-btn2 {
		cursor: pointer;
		position: absolute;
		top: 16px;
		right: 20px;
		width: 25px;
		height: 25px;
	}

	.dicom-settings-panel {
		top: 20px;
		max-height: calc(100% - 20px);

	}
}
</style>

<style scoped>
.annotation-column {
	display: none;
	padding-left: 3px;
	background-color: white;
	/* border: 1px solid green; */
}

.annotation-tool {
	width: 26px;
	height: 26px;
}

.annotation-save-btn {
	margin-top: 2px;
}

.annotation-nrrd-btn {
	margin-top: 2px;
}

.annotation-view-btn {
	margin-top: 3px;
}

.annotation-numbers-btn {
	margin-top: -4px;
	margin-left: -7px;
	width: 37px;
	height: 39px;
}

.annotation-contour-btn {
	margin-top: 1px;
	margin-left: 7px;
	width: 30px;
	height: 30px;
}

.annotation-brush-btn {
	margin-top: 1px;
	margin-left: -6px;
	width: 31px;
	height: 31px;
}

.annotation-draw-btn {
	margin-top: 3px;
	margin-left: 2px;
	width: 30px;
	height: 30px;
	/* border: 1px solid #FFFFFF; */
}

.annotation-erase-btn {
	margin-top: 3px;
	margin-left: -9px;
	width: 30px;
	height: 30px;
}

.annotation-undo-btn {
	margin-top: 3px;
	margin-left: 5px;
	width: 33px;
	height: 33px;
}

.annotation-redo-btn {
	margin-top: 3px;
	margin-left: -6px;
	width: 33px;
	height: 33px;
}

.annotation-on-item {
	display: none;
}
</style>

<style>
/* .layerGroup {
	position: relative;
	padding: 0;
	display: flex;
	justify-content: center;
	height: 90%;
} */

.layer {
	position: absolute;
	pointer-events: none;
}

.dicom-intersection-cont {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 1;
	pointer-events: none;
	/* background: orange; */
	/* opacity: 0.3; */
}

.dicom-intersection {
	position: absolute;
	border: none;
	margin: 0;
	/* border-top: 2px dashed lime; */
	z-index: 99;
}

.dicom-intersection-circle {
	position: absolute;
	border: none;
	margin: 0;
	z-index: 99;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background: transparent;
	/* cursor: move; */
	pointer-events: auto;
	opacity: 0.5;
}

.dicom-intersection-circle:hover {
	background: white;
}

.dicom-intersection.horizontal {
	width: 100%;
}

.dicom-intersection.hc {
	margin-top: -1px;
	left: -100%;
	width: 300%;
}

.dicom-intersection.vertical {
	height: 100%;
}

.dicom-intersection.vc {
	margin-left: -1px;
	top: -100%;
	height: 300%;
}

.projection-icon {
	pointer-events: auto;
	position: absolute;
	cursor: pointer;
	width: 20px;
	height: 20px;
	opacity: 0.7;
	/* user-drag: none; */
	-webkit-user-drag: none;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	z-index: 200;
}

.projection-icon.img-move-hor1 {
	left: 45px;
	top: -11px;
}

.projection-icon.img-move-hor2 {
	left: calc(100% - 65px);
	top: -11px;
}

.projection-icon.img-move-vert1 {
	top: 45px;
	left: -11px;
}

.projection-icon.img-move-vert2 {
	top: calc(100% - 65px);
	left: -11px;
}

.projection-icon.img-rotate-hor1 {
	left: 65px;
	top: -11px;
}

.projection-icon.img-rotate-hor2 {
	left: calc(100% - 85px);
	top: -11px;
}

.projection-icon.img-rotate-vert1 {
	top: 65px;
	left: -11px;
}

.projection-icon.img-rotate-vert2 {
	top: calc(100% - 85px);
	left: -11px;
}

/* .projection-rotate {
	display: none;
} */

.dicom-slider-container {
	position: absolute;
	text-align: center;
	width: 35px;
	left: 5px;
	top: 110px;
	height: calc(100% - 230px);
	z-index: 3;
}

.dicom-span {
	color: #FFFFFF;
	display: block;
	font-size: small;
}

.dicom-slider {
	height: calc(100% - 7px);
	border-radius: 0;
	outline: none;
	width: 0.43rem;
	margin-top: 15px;
	margin-bottom: 10px;
	margin-left: calc(50% - 0.25rem);
}

.dicom-slider-btn {
	cursor: pointer;
	width: 30px;
	height: 30px;
}

.dicom-slider .ui-slider-range {
	display: none;
}

.dicom-slider .ui-slider-handle {
	outline: none;
	border-radius: 30px;
	width: 1.6rem;
	height: 1.6rem;
	left: -.65rem;
}
</style>